export const submitOrder = async (orderData) => {
  try {
    const apiUrl =
      process.env.REACT_APP_API_URL || "https://api.gardeniaflowers.md";
    // const apiUrl = "http://localhost:5012";

    const response = await fetch(`${apiUrl}/api/orders`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(orderData),
    });
    const responseText = await response.text();

    // Try to parse the response as JSON
    let data;
    try {
      data = JSON.parse(responseText);
    } catch (parseError) {
      console.error("Failed to parse order response as JSON:", parseError);
      throw new Error("Server returned invalid JSON response");
    }

    if (!response.ok) {
      throw new Error(data.error || "Failed to submit order");
    }

    return data;
  } catch (error) {
    console.error("Order submission error:", error);
    throw error;
  }
};
// export const submitOrder = async (orderData) => {
//   try {
//     const apiUrl =
//       process.env.REACT_APP_API_URL || "https://api.gardeniaflowers.md";
//     // const apiUrl = "http://localhost:5012";

//     console.log("Submitting order to:", `${apiUrl}/api/orders`);
//     console.log("User agent:", navigator.userAgent);

//     const response = await fetch(`${apiUrl}/api/orders`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(orderData),
//     });

//     console.log("Response status:", response.status);
//     console.log("Response headers:", Object.fromEntries([...response.headers]));

//     const responseText = await response.text();
//     console.log(
//       "Response text:",
//       responseText.substring(0, 200) + (responseText.length > 200 ? "..." : "")
//     );

//     // Try to parse the response as JSON
//     let data;
//     try {
//       data = JSON.parse(responseText);
//     } catch (parseError) {
//       console.error("Failed to parse order response as JSON:", parseError);
//       console.error("Raw response:", responseText);
//       throw new Error(
//         `Server returned invalid JSON response (Status: ${response.status})`
//       );
//     }

//     if (!response.ok) {
//       console.error("Server error details:", data);
//       throw new Error(
//         data.error || `Failed to submit order (Status: ${response.status})`
//       );
//     }

//     return data;
//   } catch (error) {
//     console.error("Order submission error:", error);
//     console.error("Error details:", {
//       message: error.message,
//       stack: error.stack,
//       name: error.name,
//     });

//     // Add network diagnostics
//     try {
//       const online = navigator.onLine;
//       console.log("Network status - Online:", online);

//       // Try to fetch a simple resource to test connectivity
//       fetch("https://api.gardeniaflowers.md/test")
//         .then((r) => console.log("Basic connectivity test:", r.status))
//         .catch((e) => console.log("Basic connectivity failed:", e.message));
//     } catch (diagError) {
//       console.log("Diagnostics error:", diagError);
//     }

//     throw error;
//   }
// };
